import React from 'react';
import { connect } from 'react-redux';
import ProductSummary from './ProductSummary';

const ProductSummaryContainer = ({
  productInCart,
  isLastProductInCart,
  isForPreview,
  validatedCart,
  isForCombo,
}) => {
  return (
    <ProductSummary
      productInCart={productInCart}
      isLastProductInCart={isLastProductInCart}
      isForPreview={isForPreview}
      validatedCart={validatedCart}
      isForCombo={isForCombo}
    />
  );
};

const mapStateToProps = (state) => ({
  validatedCart: state.cartReducer.validatedCart,
  isForPreview: state.cartReducer.isForPreview,
});

export default connect(mapStateToProps)(ProductSummaryContainer);
